import createAction from './createAction';

// because icepick is implemented using commonjs modules,
// which we don't suppport, it has to be required in this way
const icepick = require('../../../node_modules/icepick/icepick.min');

// 1. Initial state
const initialState = icepick.freeze({});

// 2. Actions
const ADD_PRODUCT_INFO = 'productPage/productInfo/ADD_PRODUCT_INFO';

// 3. Action creators
export function addProductInfo(productInfoData) {
  return createAction(ADD_PRODUCT_INFO)(productInfoData);
}

// 4. Reducer
export default function reducer(state = initialState, action) {

  switch (action.type) {
    case ADD_PRODUCT_INFO: {
      return icepick.merge(state, parseAndReturnProductInfo(action.payload));
    }
    default: {
      return state;
    }
  }
}

function parseAndReturnProductInfo(unparsedProductInfo) {
  return {
    productID: unparsedProductInfo.productID,
    manufacturer: unparsedProductInfo.manufacturer,
    productName: unparsedProductInfo.productName,
    imageUrl: unparsedProductInfo.imageUrl,
    currentPrice: unparsedProductInfo.currentPrice,
    savingsPrice: unparsedProductInfo.savingsPrice,
    wasPrice: unparsedProductInfo.wasPrice,
    wasPriceFrom: unparsedProductInfo.wasPriceFrom,
    wasPriceTo: unparsedProductInfo.wasPriceTo,
    mainProductWasPrice: unparsedProductInfo.mainProductWasPrice,
    mainProductCurrentPrice: unparsedProductInfo.mainProductCurrentPrice,
    isInStock: unparsedProductInfo.isInStock,
    reviewRating: unparsedProductInfo.reviewRating,
    numberOfReviews: unparsedProductInfo.numberOfReviews,
    separateSellingPrice: unparsedProductInfo.separateSellingPrice,
    inStorePrice: unparsedProductInfo.inStorePrice,
    perMonthPrice: unparsedProductInfo.perMonthPrice,
    isFlashSale: unparsedProductInfo.isFlashSale

  };
}
